import jaherLogo from './logojaher-webreg.png';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './navbar.css';

const Navbar = () => {
    const { user, logout, isAdmin } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                {/* LEFT: BRAND SECTION */}
                <div className="navbar-brand-section">
                    <div className="brand-logo">
                        <h2>Video Manager</h2>
                    </div>
                    <div className="brand-divider"></div>
                    <div className="brand-context">
                        <span className="context-title">Panel de Control</span>
                    </div>
                </div>

                {/* CENTER: LOGO AREA */}
                <div className="navbar-center-logo">
                    <img src={jaherLogo} alt="Logo" className="jaher-logo" />
                </div>

                {/* RIGHT: USER SECTION */}
                <div className="navbar-user-section">
                    <div className="user-info-group">
                        <span className="welcome-text">Bienvenido, <strong>{user?.name}</strong></span>
                        <span className={`role-badge ${isAdmin ? 'admin' : 'user'}`}>
                            {isAdmin ? 'Administrador' : 'Usuario'}
                        </span>
                    </div>

                    <button onClick={handleLogout} className="btn-logout-premium" title="Cerrar Sesión">
                        <span className="logout-icon">➜</span>
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
